export default "__VITE_ASSET__DOuKESQj__"